/**
 * Canonical grid container for every suite's tool tiles.
 *
 * Single source so the column behavior can't drift across the 5 suites
 * (they previously each carried a byte-identical inline grid div — one
 * shared component removes that drift, same principle as ToolCard).
 *
 * Phone is PINNED to exactly 3 columns (locked decision): the
 * grid-balance reasoning (V30 counts): Chem 9 & Phys 9 = clean 3×3 on
 * phone; Math 6, Tools 6, Bio 6 = 2 rows of 3 — only holds if the
 * column count is
 * deterministic. `auto-fill` would let some phones fall to 2 columns
 * and silently break that model. Wider screens keep the fluid
 * auto-fill behavior (more tools per row on desktop/tablet).
 *
 * Tradeoff acknowledged: at exactly 3 columns on the smallest phones
 * tiles are ~108px and the name-below label is tighter. That is a
 * known, device-testable cost of a deterministic layout; flagged, not
 * hidden. The font/wrap can be tuned later from a real device.
 */
export function ToolGrid({ children }) {
  const cls = "tool-grid";
  return (
    <div className={cls}>
      <style>{`
        .${cls} {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
          gap: 18px;
          padding: 4px 0;
        }
        /* Phones: pin to exactly 3 columns so the balance model holds. */
        @media (max-width: 480px) {
          .${cls} { grid-template-columns: repeat(3, 1fr); gap: 12px; }
        }
      `}</style>
      {children}
    </div>
  );
}

export default ToolGrid;
